import { Button, ClickEvent, Toast } from "@mcleod/components";
import { AutogenLayoutCarrierScorecardProfileList } from "./autogen/AutogenLayoutCarrierScorecardProfileList";
import { CommonDialogs } from "@mcleod/common";
import { Api } from "@mcleod/core";
import { CarrierPerfCalculationCleanup } from "./CarrierPerfCalculationCleanup";

export class CarrierScorecardProfileList extends AutogenLayoutCarrierScorecardProfileList {
    onLoad(): void | Promise<void> {
        this.tableCarrierScorecardProfiles.addAfterCrudCloseListener(() => {
            this.mainDataSource.search(this.mainDataSource.lastSearch);
        });
    }

    sourceCarrierScorecardProfileAfterExecution(event: ClickEvent) {
        this.buttonCalculate.enabled = this.mainDataSource.data.some(profile => profile.getBoolean("is_active", false));
    }

    buttonDeleteResultsOnClick(event: ClickEvent) {
        const button = event.target as Button;
        button.busy = true;
        return CarrierPerfCalculationCleanup.showSlideout()
        .finally(() => button.busy = false);
    }

    buttonCalculateOnClick(event: ClickEvent) {
        const button = event.target as Button;
        button.busy = true;
        return CommonDialogs.showYesNo("Calculating Carrier Scoring may take a while to complete and may impact system performance."
                                        + "\n\nAn email will be sent to the Notification Email set in PowerBroker//web control.",
                                        "Calculate Carrier Scores"
        ).then((result) => {
            if (result) {
                return Api.post("lme/powerbroker/start-carrier-performance")
                .then(result => Toast.showSuccessToast("Calculating carrier scores, confirmation email will be sent when process is complete."))
            }
        }).finally(() => button.busy = false);
    }
}
